import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { useParams } from 'react-router-dom';
import Editor from '@monaco-editor/react';
import axiosInstance from 'api/axiosInstance';
import apiUrls from 'api/apiUrls';
import JSZip from 'jszip';
import InterfaceSelect from 'components/select';
import {
  Box,
  Flex,
  Button,
  // Text,
  // useDisclosure,
  // Select,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useColorModeValue,
  useColorMode,
  useToast,
  Text,
  RadioGroup,
  Stack,
  Radio,
  Center,
  Heading,
} from '@chakra-ui/react';
import FileExplorer from './FileExplorer';
import Card from 'components/card/Card';
// import { useNavigate } from 'react-router-dom';
import { Skeleton, SkeletonText } from '@chakra-ui/react';
// import { useLocation } from 'react-router-dom';
import GlobalAlertDialog from 'components/GlobalAlertDialog';
import { useLocation, useNavigate } from 'react-router-dom';
import { Checkbox, SimpleGrid } from '@chakra-ui/react';
import GlobalModal from 'components/GlobalModal';
import { InputGroup, InputLeftElement } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import Default from 'components/fields/InputField';
import Cookies from 'js-cookie';
import ClusterModal from 'components/ClusterModal';
import { sortDevices } from 'views/hooks/sortDevices';

const NameModal = ({
  isOpen,
  onClose,
  title,
  placeholder,
  value,
  onChange,
  onConfirm,
  confirmLabel = 'Confirm',
  isConfirmDisabled = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg={useColorModeValue('white', 'navy.700')}>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            color={useColorModeValue('navy.700', 'white')}
            placeholder={placeholder}
            autoFocus
            value={value}
            onChange={onChange}
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={onConfirm}
            isDisabled={isConfirmDisabled}
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const Logic = () => {
  const userAuthority = localStorage.getItem('userAuthority');
  const customerId = localStorage.getItem('customerId');
  const isTenantAdmin = userAuthority === 'TENANT_ADMIN';
  const platformId = process.env.REACT_APP_PLATFORM_ID;
  const groupID = localStorage.getItem('groupID');
  const toast = useToast();
  const { colorMode } = useColorMode();
  // const navigate = useNavigate();
  // const { deviceUUID } = useParams();
  const location = useLocation();
  const deviceId = localStorage.getItem('deviceId');

  const [patchNameModalOpen, setPatchNameModalOpen] = useState(false);

  const [pythonCode, setPythonCode] = useState('');
  const [files, setFiles] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [editorTheme, setEditorTheme] = useState(
    useColorModeValue('vs-light', 'vs-dark'),
  );

  useEffect(() => {
    const newTheme = colorMode === 'dark' ? 'vs-dark' : 'vs-light';
    setEditorTheme(newTheme);
  }, [colorMode]);

  // Wrap generateId in useCallback to stabilize its reference
  const generateId = useCallback(
    () => `id_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const [loading, setLoading] = useState(true);
  const [patchName, setPatchName] = useState('');
  const [patchConfigMap, setPatchConfigMap] = useState({});
  const [patchOptions, setPatchOptions] = useState([]); // <-- change from patchConfigMap
  const [patchId, setPatchId] = useState(null);
  const [patchVersion, setPatchVersion] = useState(0);
  const navigate = useNavigate();

  const panelBg = useColorModeValue('white', 'navy.700');
  const optionText = useColorModeValue('navy.800', 'white');

  // Rename Modal state
  const [renameState, setRenameState] = useState({
    isOpen: false,
    item: null,
    newName: '',
  });
  // Delete confirmation state
  const [deleteState, setDeleteState] = useState({ isOpen: false, item: null });
  // Create file modal state
  const [createFileState, setCreateFileState] = useState({
    isOpen: false,
    parent: null,
    fileName: '',
  });
  // Create folder modal state
  const [createFolderState, setCreateFolderState] = useState({
    isOpen: false,
    parent: null,
    folderName: '',
  });
  const [isSaveLogicModalOpen, setIsSaveLogicModalOpen] = useState(false);
  const [devicesArray, setDevicesArray] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([deviceId]);
  const [loadingDevices, setLoadingDevices] = useState(false);

  const [serialNumber, setSerialNumber] = useState('');
  const [hasNext, setHasNext] = useState(false);
  const [searchType, setSearchType] = useState('deviceId');
  // New states for cluster search
  const [clusterOptions, setClusterOptions] = useState([]);
  const [selectedCluster, setSelectedCluster] = useState('');
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [nocOptions, setNocOptions] = useState([]);
  const [selectedNoc, setSelectedNoc] = useState('');
  const [plantOptions, setPlantOptions] = useState([]);
  const [selectedPlant, setSelectedPlant] = useState('');
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [selectedClusterDevice, setSelectedClusterDevice] = useState('');
  const [patchDeviceMap, setPatchDeviceMap] = useState({});

  const isFirstRender = useRef(true);

  const [currentPage, setCurrentPage] = useState(0);
  const fetchAllDevices = useCallback(
    async (serialNumber = '', setLoading = true, page = 0) => {
      setLoadingDevices(setLoading);
      let apiUrl = apiUrls.allDevices(serialNumber, page);

      const resp = await axiosInstance.get(apiUrl);
      const devices = resp.data.data;
      setHasNext(resp.data.hasNext);
      const devicesNameIdMap = sortDevices(devices.map((d) => d.name)).map(
        (name) => ({
          id: name,
          name,
        }),
      );
      if (serialNumber || page === 0) {
        setDevicesArray(devicesNameIdMap);
      } else {
        const newDevices = devicesNameIdMap.filter((d) => {
          if (deviceId !== d.id) {
            return !selectedDevices.includes(d.id);
          } else {
            return true;
          }
        });
        setDevicesArray((prev) => [...prev, ...newDevices]);
      }

      setLoadingDevices(false);
    },
    [deviceId],
  );

  const fetchPatchesWithDevices = () => {
    setLoadingDevices(true);
    const keys = 'patches';
    axiosInstance
      .get(apiUrls.fetchModbusConfigsandpatches(platformId, groupID, keys))
      .then((res) => {
        const patches = res.data.patches || [];
        const map = {};
        patches.forEach((cfg) => {
          // Map to array of device IDs, not array of objects
          map[cfg.id] = (cfg.devices || []).map((d) => d.device_id);
        });
        setPatchDeviceMap(map);
        console.log('Patches with devices:', map);
      })
      .catch((err) => {
        console.error('Error fetching patches:', err);
        setLoadingDevices(false);
      });
  };
  const preselectedPatchDevices = patchDeviceMap[patchId] || [];
  useEffect(() => {
    fetchPatchesWithDevices();
  }, [platformId, groupID]);

  useEffect(() => {
    fetchPatches();
  }, [platformId]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (serialNumber) {
      setCurrentPage(0);
    }

    if (currentPage === -1) return;

    if (searchType === 'deviceId') {
      fetchAllDevices(serialNumber, true, currentPage);
    }
  }, [currentPage, serialNumber, fetchAllDevices, searchType]);
  const handleCheckboxChange = (id) => {
    setSelectedDevices((prev) =>
      prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id],
    );
  };

  const handleSaveLogicToDevices = async () => {
    if (!patchName.trim()) return;
    const hasMain = files.some(
      (f) => f.type === 'file' && f.name === 'main.py',
    );
    const hasRequirements = files.some(
      (f) => f.type === 'file' && f.name === 'requirements.txt',
    );
    const versionFile = files.find(
      (f) => f.type === 'file' && f.name === 'version.txt',
    );
    if (!hasMain || !hasRequirements) {
      toast({
        title: 'Missing Required Files',
        description:
          "Make sure 'main.py' and 'requirements.txt' exist before uploading.",
        status: 'warning',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    if (!versionFile || !versionFile.content || !versionFile.content.trim()) {
      toast({
        title: 'Missing Version',
        description: "The 'version.txt' file must not be empty.",
        status: 'error',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    if (!/^v\d+$/i.test(versionFile.content.trim())) {
      toast({
        title: 'Invalid Version Format',
        description:
          "The 'version.txt' file must be in the format 'v1', 'v2', etc.",
        status: 'error',
        position: 'top',
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    const versionMatch = patchName.match(/v?(\d+)/i);
    const patchVersion = versionMatch ? parseInt(versionMatch[1], 10) : 1;

    const zip = new JSZip();
    const buildZipTree = (currentFolder, parent) => {
      const children = files.filter(
        (f) => f.parentId === (parent ? parent.id : null),
      );
      for (const item of children) {
        if (item.type === 'file') {
          currentFolder.file(item.name, item.content || '');
        } else if (item.type === 'folder') {
          const newFolder = currentFolder.folder(item.name);
          buildZipTree(newFolder, item);
        }
      }
    };
    buildZipTree(zip, null);
    try {
      const blob = await zip.generateAsync({ type: 'blob' });
      const arrayBuffer = await blob.arrayBuffer();
      const base64Data = btoa(
        new Uint8Array(arrayBuffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          '',
        ),
      );

      const checkedDeviceIds = devicesArray
        .filter((d) => selectedDevices.includes(d.id))
        .map((d) => d.name);

      let allDeviceIds = checkedDeviceIds.includes(deviceId)
        ? checkedDeviceIds
        : [...checkedDeviceIds, deviceId];

      allDeviceIds = Array.from(new Set(allDeviceIds.filter(Boolean)));
      for (const deviceName of allDeviceIds) {
        const payload = {
          addPatchToDevice: 1,
          content: base64Data,
          version: patchVersion,
          patch_id: patchId,
          patch_name: patchName,
        };
        await axiosInstance.post(apiUrls.savePatch(deviceName), payload);
      }

      toast({
        title: 'Upload Successful',
        description: 'Files zipped and uploaded successfully.',
        status: 'success',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
      setIsSaveLogicModalOpen(false);
      await fetchPatches();
      await fetchConfigurations();
      await fetchPatchesWithDevices();
    } catch (err) {
      console.error('Upload failed:', err);
      toast({
        title: 'Upload Failed',
        description: 'An error occurred while uploading the zip.',
        status: 'error',
        position: 'top',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // useEffect(() => {
  //   console.log(editorTheme)
  // }, [editorTheme]);

  // const handleUploadClick = () => {
  //   setPatchNameModalOpen(true);
  // };

  // Wrap initializeDefault in useCallback
  const initializeDefault = useCallback(() => {
    const projectFolderId = generateId();
    const mainFileId = generateId();
    const reqFileId = generateId();
    const versionFileId = generateId();

    const struct = [
      {
        id: projectFolderId,
        name: 'Project',
        type: 'folder',
        parentId: null,
      },
      {
        id: mainFileId,
        name: 'main.py',
        type: 'file',
        content: '# main\n',
        parentId: projectFolderId,
      },
      {
        id: reqFileId,
        name: 'requirements.txt',
        type: 'file',
        content: '',
        parentId: projectFolderId,
      },
      {
        id: versionFileId,
        name: 'version.txt',
        type: 'file',
        content: 'v1',
        parentId: projectFolderId,
      },
    ];

    setFiles(struct);
    setSelectedFile(struct[1]);
    setPythonCode(struct[1].content);

    return struct;
  }, [generateId, setFiles, setSelectedFile, setPythonCode]);

  // Move fillData function inside Logic component and wrap in useCallback
  // Move fillData above fetchPatchDetails and fetchConfigurations
  const fillData = useCallback(
    async (resp) => {
      const patchValue = resp.data?.find(({ key }) => key === 'patch')?.value;
      setPatchName(
        resp.data?.find(({ key }) => key === 'patch_name')?.value || '',
      );
      // Don't set patchId here since we already set it in fetchConfigurations
      // setPatchId(
      //   resp.data?.find(({ key }) => key === 'patch_id')?.value || null,
      // );
      setPatchVersion(
        parseInt(
          resp.data?.find(({ key }) => key === 'patch_v')?.value || '0',
          10,
        ),
      );

      if (!patchValue) {
        const defaultStruct = initializeDefault();
        setFiles(defaultStruct);
        return;
      }

      // Rest of your fillData code remains the same...
      // (keep all the zip parsing logic)
    },
    [generateId, initializeDefault],
  );
  // Move fetchConfigurations above useEffect that uses it
  const fetchConfigurations = useCallback(async () => {
    try {
      const keys = 'patch,patch_v,patch_name,patch_id';
      const resp = await axiosInstance.get(
        apiUrls.toolDeviceAttributes(deviceId, keys),
      );

      // Get the actual patch_id from the response
      const actualPatchId = resp.data?.find(
        ({ key }) => key === 'patch_id',
      )?.value;

      const patchV = resp.data?.find(({ key }) => key === 'patch_v')?.value;
      setPatchVersion(parseInt(patchV || '0', 10));

      if (actualPatchId) {
        // Set the patchId first
        setPatchId(actualPatchId);

        // Then load the actual patch content
        await handlePatchSelectChange(actualPatchId);
      } else {
        // No patch applied, initialize default
        await fillData(resp);
      }
    } catch (err) {
      console.error('Failed to fetch file explorer:', err);
      initializeDefault();
    } finally {
      setLoading(false);
    }
  }, [deviceId, fillData, initializeDefault]);

  // Remove this useEffect:
  // useEffect(() => {
  //   if (patchId) {
  //     fetchPatchDetails();
  //   }
  // }, [patchId, fetchPatchDetails]);

  // Move fetchPatches above its first use
  const [patchDetailsMap, setPatchDetailsMap] = useState({});

  // Remove this useEffect that auto-selects first patch
  // useEffect(() => {
  //   if (patchOptions.length > 0 && !patchId) {
  //     const firstPatchId = patchOptions[0].value;
  //     setPatchId(firstPatchId);
  //     handlePatchSelectChange(firstPatchId);
  //   }
  // }, [patchOptions, patchId]);

  // Update fetchPatches to NOT auto-select
  const fetchPatches = useCallback(async () => {
    try {
      const keys = 'patches';
      const resp = await axiosInstance.get(
        apiUrls.groupAttributes(deviceId, keys),
      );
      const attrMap = Object.fromEntries(
        resp.data.map((a) => [a.key, a.value]),
      );

      let patchOptionsArr = [];
      if (Array.isArray(attrMap.patches)) {
        patchOptionsArr = attrMap.patches.map((patch) => ({
          label: patch.filename || 'Unnamed',
          value: patch.id || '',
        }));
      }

      setPatchOptions(patchOptionsArr);

      // Fetch patch details for each patch (keep this part)
      const detailsMap = {};
      if (Array.isArray(attrMap.patches)) {
        await Promise.all(
          attrMap.patches.map(async (patch) => {
            const id = patch.id;
            if (id) {
              try {
                const codeResp = await axiosInstance.get(
                  apiUrls.getPatchCode(id),
                );
                const dataResp = await axiosInstance.get(
                  apiUrls.getpatchdata(id),
                );
                const latestCodeResp = await axiosInstance.get(
                  apiUrls.getPatchCode(id),
                );
                const latestDataResp = await axiosInstance.get(
                  apiUrls.getpatchdata(id),
                );
                detailsMap[id] = {
                  code: latestCodeResp.data,
                  data: latestDataResp.data,
                };
              } catch (err) {
                detailsMap[id] = { code: null, data: null };
              }
            }
          }),
        );
      }
      setPatchDetailsMap(detailsMap);
    } catch (err) {
      console.error('Failed to fetch configurations', err);
    } finally {
      setLoading(false);
    }
  }, [deviceId]);

  // const fetchPatches = useCallback(async () => {
  //   try {
  //     const keys = 'patches';z
  //     const resp = await axiosInstance.get(
  //       apiUrls.groupAttributes(deviceId, keys),
  //     );
  //     const attrMap = Object.fromEntries(
  //       resp.data.map((a) => [a.key, a.value]),
  //     );

  //     const patchConfigMap = attrMap.patches.reduce((acc, i) => {
  //       const id = i.id || '';
  //       const name = i.filename || '';
  //       acc[name] = id;
  //       return acc;
  //     }, {});

  //     setPatchConfigMap(patchConfigMap);

  //     // Auto-select first patch if available and none is selected
  //     const patchIds = Object.values(patchConfigMap);
  //     if (patchIds.length > 0 && !patchId) {
  //       setPatchId(patchIds[0]);
  //       // Also trigger the logic to load the patch
  //       handlePatchSelectChange(patchIds[0]);
  //     }
  //   } catch (err) {
  //     console.error('Failed to fetch configurations', err);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [deviceId, patchId]);

  // Helper to decode base64 zip and return file structure
  const decodeBase64ZipToFiles = async (base64, generateId) => {
    const zip = new JSZip();
    const binaryStr = atob(base64);
    const byteArray = Uint8Array.from(binaryStr, (c) => c.charCodeAt(0));
    const unzipped = await zip.loadAsync(byteArray);

    const filesList = [];
    const folderMap = {};
    let rootFolderId = null;

    if (!unzipped.folder('Project/')) {
      rootFolderId = generateId();
      folderMap['Project'] = rootFolderId;
      filesList.push({
        id: rootFolderId,
        name: 'Project',
        type: 'folder',
        parentId: null,
      });
    }

    await Promise.all(
      Object.keys(unzipped.files).map(async (filePath) => {
        const zipEntry = unzipped.files[filePath];
        const segments = filePath.split('/').filter(Boolean);
        if (segments.length === 0) return;

        let currentPath = 'Project';
        let parentId = rootFolderId;

        for (let i = 0; i < segments.length - (zipEntry.dir ? 0 : 1); i++) {
          currentPath += `/${segments[i]}`;
          if (!folderMap[currentPath]) {
            const id = generateId();
            folderMap[currentPath] = id;
            filesList.push({
              id,
              name: segments[i],
              type: 'folder',
              parentId,
            });
          }
          parentId = folderMap[currentPath];
        }

        if (!zipEntry.dir) {
          const fileName = segments[segments.length - 1];
          const content = await zipEntry.async('text');
          filesList.push({
            id: generateId(),
            name: fileName,
            type: 'file',
            content,
            parentId,
          });
        }
      }),
    );

    const hasRootFolder = filesList.some(
      (f) => f.parentId === null && f.type === 'folder',
    );
    if (!hasRootFolder) {
      const projectId = generateId();
      filesList.forEach((f) => {
        if (f.parentId === null) f.parentId = projectId;
      });

      filesList.unshift({
        id: projectId,
        name: 'Project',
        type: 'folder',
        parentId: null,
      });
    }

    return filesList;
  };

  // Handler for patch select change
  const handlePatchSelectChange = async (val) => {
    setPatchId(val);
    // Find the selected patch's name from patchOptions
    const selectedPatch = patchOptions.find((opt) => opt.value === val);
    if (selectedPatch) {
      setPatchName(selectedPatch.label || '');
    }
    if (val) {
      try {
        const resp = await axiosInstance.get(apiUrls.getPatchCode(val));
        // Find the patch base64 value
        const patchObj = Array.isArray(resp.data)
          ? resp.data.find((item) => item.key === 'patch')
          : null;
        const patchBase64 = patchObj?.value;
        if (patchBase64) {
          const explorer = await decodeBase64ZipToFiles(
            patchBase64,
            generateId,
          );
          setFiles(explorer);
          // Pick main.py or first file
          const pick =
            explorer.find((f) => f.type === 'file' && f.name === 'main.py') ||
            explorer.find((f) => f.type === 'file') ||
            null;
          if (pick) {
            setSelectedFile(pick);
            setPythonCode(pick.content);
          } else {
            setSelectedFile(null);
            setPythonCode('');
          }
        }
      } catch (err) {
        console.error('getPatchCode failed:', err);
      }
    }
  };

  useEffect(() => {
    fetchPatches();
  }, [fetchPatches]);

  // Add this useEffect to auto-select first patch after patchConfigMap is set
  // useEffect(() => {
  //   if (patchOptions.length > 0 && !patchId) {
  //     const firstPatchId = patchOptions[0].value;
  //     setPatchId(firstPatchId);
  //     handlePatchSelectChange(firstPatchId);
  //   }
  // }, [patchOptions, patchId]);

  useEffect(() => {
    fetchConfigurations();
  }, [fetchConfigurations]);

  // Rename handlers
  const openRename = (item) =>
    setRenameState({ isOpen: true, item, newName: item.name });
  const closeRename = () =>
    setRenameState({ isOpen: false, item: null, newName: '' });
  const handleRenameConfirm = () => {
    if (renameState.newName.trim()) {
      setFiles((prev) =>
        prev.map((f) =>
          f.id === renameState.item.id
            ? { ...f, name: renameState.newName.trim() }
            : f,
        ),
      );
      if (selectedFile?.id === renameState.item.id) {
        setSelectedFile({
          ...renameState.item,
          name: renameState.newName.trim(),
        });
      }
    }
    closeRename();
  };

  // Delete handlers
  const openDelete = (item) => setDeleteState({ isOpen: true, item });
  const closeDelete = () => setDeleteState({ isOpen: false, item: null });
  const handleDeleteConfirm = () => {
    setFiles((prev) => prev.filter((f) => f.id !== deleteState.item.id));
    if (selectedFile?.id === deleteState.item.id) {
      setSelectedFile(null);
      setPythonCode('');
    }
    closeDelete();
  };

  // Create file handlers
  const openCreateFile = (parent) =>
    setCreateFileState({ isOpen: true, parent, fileName: '' });
  const closeCreateFile = () =>
    setCreateFileState({ isOpen: false, parent: null, fileName: '' });
  const handleCreateFileConfirm = () => {
    const nm = createFileState.fileName.trim();
    if (nm) {
      const id = generateId();
      const f = {
        id,
        name: nm,
        type: 'file',
        content: '',
        parentId: createFileState.parent?.id || null,
      };
      setFiles((prev) => [...prev, f]);
      setSelectedFile(f);
      setPythonCode('');
    }
    closeCreateFile();
  };

  // Create folder handlers
  const openCreateFolder = (parent) =>
    setCreateFolderState({ isOpen: true, parent, folderName: '' });
  const closeCreateFolder = () =>
    setCreateFolderState({ isOpen: false, parent: null, folderName: '' });
  const handleCreateFolderConfirm = () => {
    const nm = createFolderState.folderName.trim();
    if (nm) {
      const id = generateId();
      const f = {
        id,
        name: nm,
        type: 'folder',
        parentId: createFolderState.parent?.id || null,
      };
      setFiles((prev) => [...prev, f]);
    }
    closeCreateFolder();
  };

  const handleImportFile = (file, parentFolder = null) => {
    const reader = new FileReader();
    reader.onload = () => {
      const content = reader.result;
      const id = generateId();
      const newFile = {
        id,
        name: file.name,
        type: 'file',
        content,
        parentId: parentFolder?.id || null,
      };
      setFiles((prev) => [...prev, newFile]);
      setSelectedFile(newFile);
      setPythonCode(content);
    };
    reader.readAsText(file);
  };

  const handleFolderImport = (fileList, parentFolder = null) => {
    const folderMap = {}; // To track created folders and their IDs

    // Get root folder name from the first file
    const firstFile = fileList[0];
    const fullPath = firstFile?.webkitRelativePath || firstFile?.name;
    const baseFolderName = fullPath?.split('/')?.[0];

    // Create the root folder (if not already passed as parentFolder)
    let rootFolderId = parentFolder?.id || null;

    if (!parentFolder && baseFolderName) {
      rootFolderId = generateId();
      const rootFolder = {
        id: rootFolderId,
        name: baseFolderName,
        type: 'folder',
        parentId: null,
      };
      setFiles((prev) => [...prev, rootFolder]);
      folderMap[baseFolderName] = rootFolderId;
    }

    const createFolder = (folderPath) => {
      if (folderMap[folderPath]) return folderMap[folderPath];

      const parts = folderPath.split('/');
      const folderName = parts[parts.length - 1];
      const parentPath = parts.slice(0, -1).join('/');
      const parentId = parentPath ? createFolder(parentPath) : rootFolderId;

      const id = generateId();
      const newFolder = {
        id,
        name: folderName,
        type: 'folder',
        parentId,
      };

      setFiles((prev) => [...prev, newFolder]);
      folderMap[folderPath] = id;
      return id;
    };

    Array.from(fileList).forEach((file) => {
      const relativePath = file.webkitRelativePath || file.name;
      const cleanPath = parentFolder
        ? relativePath
        : relativePath.replace(`${baseFolderName}/`, '');

      const pathParts = cleanPath.split('/');

      const reader = new FileReader();
      reader.onload = () => {
        const content = reader.result;
        const id = generateId();

        let parentId = rootFolderId;

        if (pathParts.length > 1) {
          const folderPath = pathParts.slice(0, -1).join('/');
          parentId = createFolder(folderPath);
        }

        const newFile = {
          id,
          name: file.name,
          type: 'file',
          content,
          parentId,
        };

        setFiles((prev) => [...prev, newFile]);
        setSelectedFile(newFile);
        setPythonCode(content);
      };

      reader.readAsText(file);
    });
  };

  // const handlePatchNameConfirm = async () => {
  //   const trimmedName = patchName.trim();
  //   if (!trimmedName) return;

  //   setPatchNameModalOpen(false);
  //   uploadZipToServer(trimmedName, patchVersion);
  // };

  // const uploadZipToServer = async (versionStr, currentPatchVersion) => {
  //   const hasMain = files.some(
  //     (f) => f.type === 'file' && f.name === 'main.py',
  //   );
  //   const hasRequirements = files.some(
  //     (f) => f.type === 'file' && f.name === 'requirements.txt',
  //   );
  //   // Check for version.txt existence and content
  //   const versionFile = files.find(
  //     (f) => f.type === 'file' && f.name === 'version.txt',
  //   );
  //   if (!hasMain || !hasRequirements) {
  //     toast({
  //       title: 'Missing Required Files',
  //       description:
  //         "Make sure 'main.py' and 'requirements.txt' exist before uploading.",
  //       status: 'warning',
  //       position: 'top',
  //       duration: 4000,
  //       isClosable: true,
  //     });
  //     return;
  //   }
  //   if (!versionFile || !versionFile.content || !versionFile.content.trim()) {
  //     toast({
  //       title: 'Missing Version',
  //       description: "The 'version.txt' file must not be empty.",
  //       status: 'error',
  //       position: 'top',
  //       duration: 4000,
  //       isClosable: true,
  //     });
  //     return;
  //   }
  //   // Validate version.txt format: must be v1, v2, etc.
  //   if (!/^v\d+$/i.test(versionFile.content.trim())) {
  //     toast({
  //       title: 'Invalid Version Format',
  //       description:
  //         "The 'version.txt' file must be in the format 'v1', 'v2', etc.",
  //       status: 'error',
  //       position: 'top',
  //       duration: 4000,
  //       isClosable: true,
  //     });
  //     return;
  //   }
  //   const patchVersion =
  //     currentPatchVersion === 0 ? 1 : currentPatchVersion + 1;

  //   const zip = new JSZip();
  //   const buildZipTree = (currentFolder, parent) => {
  //     const children = files.filter(
  //       (f) => f.parentId === (parent ? parent.id : null),
  //     );
  //     for (const item of children) {
  //       if (item.type === 'file') {
  //         currentFolder.file(item.name, item.content || '');
  //       } else if (item.type === 'folder') {
  //         const newFolder = currentFolder.folder(item.name);
  //         buildZipTree(newFolder, item);
  //       }
  //     }
  //   };
  //   buildZipTree(zip, null);

  //   try {
  //     const blob = await zip.generateAsync({ type: 'blob' });
  //     const arrayBuffer = await blob.arrayBuffer();
  //     const base64Data = btoa(
  //       new Uint8Array(arrayBuffer).reduce(
  //         (data, byte) => data + String.fromCharCode(byte),
  //         '',
  //       ),
  //     );

  //     const payload = {
  //       addPatchToDevice: 1,
  //       content: base64Data,
  //       version: patchVersion,
  //       patch_id: patchId,
  //       patch_name: patchName,
  //     };
  //     await axiosInstance.post(apiUrls.savePatch(deviceId), payload);

  //     toast({
  //       title: 'Upload Successful',
  //       description: 'Files zipped and uploaded successfully.',
  //       status: 'success',
  //       position: 'top',
  //       duration: 3000,
  //       isClosable: true,
  //     });

  //     // Fetch latest values after successful upload
  //     await fetchConfigurations();
  //     await fetchPatches();
  //   } catch (err) {
  //     console.error('Upload failed:', err);
  //     toast({
  //       title: 'Upload Failed',
  //       description: 'An error occurred while uploading the zip.',
  //       status: 'error',
  //       position: 'top',
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //   }
  // };

  const themes = {
    'Light (vs-light)': 'vs-light',
    'Dark (vs-dark)': 'vs-dark',
    'High Contrast Dark': 'hc-black',
    'High Contrast Light': 'hc-light',
    'Solarized Light': 'solarized-light',
  };
  const getassetInfo = async (assetId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getassetInfo(assetId));
      return resp.data;
    } catch (err) {
      console.error('Failed to get asset info:', err);
      return null;
    }
  };

  const fetchCountries = async () => {
    try {
      const resp = await axiosInstance.get(apiUrls.getCountries());
      const options = (resp.data?.data || []).map((item) => ({
        label: item.name,
        value: item.id.id, // Use item.id.id as the value for selection
      }));
      setClusterOptions(options);
    } catch (err) {
      console.error('Failed to fetch clusters/countries:', err);
      setClusterOptions([]);
    }
  };

  // Fetch states for a selected country
  const fetchStates = async (countryId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(countryId));
      // The response is an array of relations, use to.id and toName for options
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setStateOptions(options);
    } catch (err) {
      console.error('Failed to fetch states:', err);
      setStateOptions([]);
    }
  };
  const fetchNocs = async (stateId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(stateId));
      // The response is an array of relations, use to.id and toName for options
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setNocOptions(options);
    } catch (err) {
      console.error('Failed to fetch NOCs:', err);
      setNocOptions([]);
    }
  };
  const fetchPlants = async (nocId) => {
    try {
      const resp = await axiosInstance.get(apiUrls.getChildren(nocId));
      // The response is an array of relations, use to.id and toName for options
      const options = (resp.data || []).map((item) => ({
        label: item.toName,
        value: item.to.id,
      }));
      setPlantOptions(options);
    } catch (err) {
      console.error('Failed to fetch Plants:', err);
      setPlantOptions([]);
    }
  };
  const fetchDevicesByAssetId = async (assetId) => {
    setLoadingDevices(true);
    try {
      const resp = await axiosInstance.get(apiUrls.getDevices(assetId));
      // Assuming resp.data.data is the array of devices
      const devices = resp.data.data || [];
      const devicesNameIdMap = devices.map((d) => ({
        id: d.name,
        name: d.name,
      }));
      setDevicesArray(devicesNameIdMap);
    } catch (err) {
      setDevicesArray([]);
    } finally {
      setLoadingDevices(false);
    }
  };
  const fetchClusterDevices = async (id) => {
    setLoadingDevices(true);
    try {
      const token = Cookies.get('authToken');
      const resp = await fetch(apiUrls.getClusterDevices(id), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      if (!resp.ok) throw new Error('Network response was not ok');
      const data = await resp.json();
      console.log('Cluster devices response:', data);

      const devicesNameIdMap = (data?.devices || []).map((d) => ({
        id: String(d.id), // UUID
        name: d.name, // Device name
      }));
      setDevicesArray(devicesNameIdMap);
      const preselected = devicesNameIdMap
        .filter(
          (d) =>
            preselectedPatchDevices.includes(d.id) ||
            preselectedPatchDevices.includes(d.name),
        )
        .map((d) => d.id);

      setSelectedDevices(Array.from(new Set([...preselected, deviceId])));
    } catch (err) {
      setDevicesArray([]);
      setSelectedDevices([]);
      console.error('Failed to fetch cluster devices:', err);
    } finally {
      setLoadingDevices(false);
    }
  };

  useEffect(() => {
    if (selectedCluster) {
      fetchStates(selectedCluster);

      setSelectedState('');
      setNocOptions([]);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDeviceOptions([]);
      setSelectedClusterDevice('');

      fetchClusterDevices(selectedCluster); // Only this call
    }
  }, [selectedCluster]);
  useEffect(() => {
    if (selectedState) {
      fetchNocs(selectedState);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDeviceOptions([]);
      setSelectedClusterDevice('');
      fetchClusterDevices(selectedState); // Only this call
    }
  }, [selectedState]);
  useEffect(() => {
    if (selectedNoc) {
      fetchPlants(selectedNoc);
      setSelectedPlant('');
      setDeviceOptions([]);
      setSelectedClusterDevice('');
      fetchClusterDevices(selectedNoc); // Only this call
    }
  }, [selectedNoc]);
  useEffect(() => {
    if (selectedPlant) {
      setLoadingDevices(true);
      fetchClusterDevices(selectedPlant); // Only this call
    }
  }, [selectedPlant]);
  useEffect(() => {
    if (searchType === 'cluster') {
      fetchCountries();
      setSelectedDevices(
        preselectedPatchDevices.length > 0
          ? Array.from(new Set([...preselectedPatchDevices, deviceId]))
          : [deviceId],
      );
      setSelectedCluster('');
      setStateOptions([]);
      setSelectedState('');
      setNocOptions([]);
      setSelectedNoc('');
      setPlantOptions([]);
      setSelectedPlant('');
      setDeviceOptions([]);
      setSelectedClusterDevice('');
    }
    // Optionally clear cluster selection when switching search type
    // setSelectedCluster('');
  }, [searchType]);
  useEffect(() => {
    if (patchId && patchDeviceMap[patchId]) {
      setSelectedDevices(
        Array.from(new Set([...(patchDeviceMap[patchId] || []), deviceId])),
      );
    }
  }, [patchId, patchDeviceMap]);
  useEffect(() => {
    if (searchType === 'deviceId') {
      setSelectedDevices(
        Array.from(new Set([...preselectedPatchDevices, deviceId])),
      );
    }
  }, [searchType, preselectedPatchDevices]);

  return (
    <>
      <Flex
        h="auto"
        mt={-6}
        align="center"
        justify="space-between"
        color={optionText}
        fontSize="lg"
        px={2}
        gap={2}
        mb={4}
      >
        {/* LEFT SIDE */}
        <Heading mt={5} size="lg">
          Logics
        </Heading>

        {/* RIGHT SIDE */}
        <Flex align="center" gap={4}>
          <Text fontSize="md" fontWeight="bold" mt={7}>
            Current Version: {patchVersion || 'N/A'}
          </Text>

          <FormControl w="200px">
            <FormLabel fontSize="sm">Select Logic</FormLabel>
            <InterfaceSelect
              value={patchId}
              onChange={handlePatchSelectChange}
              options={
                patchOptions.length === 0
                  ? [{ label: 'No patches available', value: '' }]
                  : patchOptions
              }
              disabled={patchOptions.length === 0 || !isTenantAdmin}
            />
          </FormControl>

          {/* Optional Button */}
          {/* <Button
      size="sm"
      colorScheme="green"
      variant="outline"
      border="2px"
      cursor="pointer"
      onClick={() => {
        navigate(location.pathname, { state: { activeTab: 4 } });
      }}
    >
      Add New Logic
    </Button> */}
        </Flex>
      </Flex>
      <Flex direction="column" h="100vh">
        {/* Main Content */}
        <Flex flex="1" overflow="hidden">
          {/* File Explorer Panel */}

          <Card
            minW="250px"
            maxW="25%"
            bg={panelBg}
            p={4}
            overflowY="auto"
            me={3}
            flexShrink={0}
          >
            {loading ? (
              <>
                <Skeleton height="40px" mb={4} />
                <SkeletonText noOfLines={10} spacing="4" />
              </>
            ) : (
              <>
                {isTenantAdmin && (
                  <Button
                    colorScheme="green"
                    onClick={() => {
                      setIsSaveLogicModalOpen(true);
                      setCurrentPage(0);
                      setSerialNumber('');
                      setSelectedDevices(
                        preselectedPatchDevices.length > 0
                          ? Array.from(
                              new Set([...preselectedPatchDevices, deviceId]),
                            )
                          : [deviceId],
                      );
                      setSearchType('deviceId');
                      const selectedPatch = patchOptions.find(
                        (opt) => opt.value === patchId,
                      );
                      setPatchName(selectedPatch?.label || '');
                      fetchAllDevices();
                    }}
                    mb={4}
                  >
                    Save
                  </Button>
                )}

                <FileExplorer
                  files={files}
                  selectedFile={selectedFile}
                  onFileSelect={(f) => {
                    setSelectedFile(f);
                    setPythonCode(f.content || '');
                  }}
                  onRenameItem={openRename}
                  onDeleteItem={openDelete}
                  onCreateFile={openCreateFile}
                  onCreateFolder={openCreateFolder}
                  onImportFile={handleImportFile}
                  onImportFolder={handleFolderImport}
                  showActions={false}
                />
              </>
            )}
          </Card>

          {/* Editor Panel */}
          <Box
            flex="1"
            pt={6}
            h="100%"
            bg={panelBg}
            borderRadius="md"
            overflow="hidden"
          >
            {loading ? (
              <Skeleton height="100%" />
            ) : selectedFile && selectedFile.type === 'file' ? (
              <>
                <Box mb={4}>
                  <Flex
                    h="auto"
                    align="center"
                    justify="space-around"
                    color={optionText}
                    fontSize="lg"
                    px={4}
                    pb={2}
                  >
                    <FormControl w="200px">
                      <FormLabel fontSize="sm">Editor Theme</FormLabel>
                      <InterfaceSelect
                        value={editorTheme}
                        onChange={(val) => setEditorTheme(val)}
                        options={themes}
                      />
                    </FormControl>
                  </Flex>
                </Box>
                <Editor
                  key={selectedFile.id}
                  language="python"
                  theme={editorTheme}
                  value={pythonCode}
                  onChange={(value) => {
                    setPythonCode(value);
                    setFiles((prev) =>
                      prev.map((f) =>
                        f.id === selectedFile.id ? { ...f, content: value } : f,
                      ),
                    );
                  }}
                  options={{
                    fontSize: 14,
                    minimap: { enabled: false },
                    automaticLayout: true,
                    readOnly: true,
                  }}
                  height="100%"
                />
              </>
            ) : (
              <Flex
                h="100%"
                align="center"
                justify="center"
                color={optionText}
                fontSize="lg"
              >
                Select a file to edit
              </Flex>
            )}
          </Box>
        </Flex>

        <NameModal
          isOpen={renameState.isOpen}
          onClose={closeRename}
          title={`Rename ${renameState.item?.type}`}
          placeholder="Enter new name"
          value={renameState.newName}
          onChange={(e) =>
            setRenameState((s) => ({ ...s, newName: e.target.value }))
          }
          onConfirm={handleRenameConfirm}
          isConfirmDisabled={!renameState.newName.trim()}
        />

        {/* Delete Confirmation */}
        <GlobalAlertDialog
          isOpen={deleteState.isOpen}
          onClose={closeDelete}
          onConfirm={handleDeleteConfirm}
          title={`Delete ${deleteState.item?.type}`}
          body={
            <>
              Are you sure you want to delete <b>{deleteState.item?.name}</b>?
              This action cannot be undone.
            </>
          }
          confirmText="Delete"
          cancelText="Cancel"
          showCancel={true}
        />

        {/* Create file handlers */}
        <NameModal
          isOpen={createFileState.isOpen}
          onClose={closeCreateFile}
          title="Create New File"
          placeholder="File name"
          value={createFileState.fileName}
          onChange={(e) =>
            setCreateFileState((s) => ({ ...s, fileName: e.target.value }))
          }
          onConfirm={handleCreateFileConfirm}
          isConfirmDisabled={!createFileState.fileName.trim()}
        />

        {/* Create Folder Modal */}
        <NameModal
          isOpen={createFolderState.isOpen}
          onClose={closeCreateFolder}
          title="Create New Folder"
          placeholder="Folder name"
          value={createFolderState.folderName}
          onChange={(e) =>
            setCreateFolderState((s) => ({ ...s, folderName: e.target.value }))
          }
          onConfirm={handleCreateFolderConfirm}
          isConfirmDisabled={!createFolderState.folderName.trim()}
        />

        <NameModal
          isOpen={patchNameModalOpen}
          onClose={() => setPatchNameModalOpen(false)}
          title="Patch Name"
          placeholder="Enter patch name..."
          value={patchName}
          onChange={(e) => setPatchName(e.target.value)}
          // onConfirm={handlePatchNameConfirm}
          isConfirmDisabled={!patchName.trim()}
        />
      </Flex>
      <ClusterModal
        isOpen={isSaveLogicModalOpen}
        onClose={() => setIsSaveLogicModalOpen(false)}
        title={`Save Logic : ${deviceId}`}
        mainInputLabel="Patch Name"
        mainInputValue={patchName}
        onMainInputChange={(e) => setPatchName(e.target.value)}
        searchType={searchType}
        onSearchTypeChange={setSearchType}
        serialNumber={serialNumber}
        onSerialNumberChange={(e) => setSerialNumber(e.target.value)}
        onSerialNumberSearch={async (e) => {
          if (e.key === 'Enter') {
            setLoadingDevices(true);
            try {
              await fetchAllDevices(e.target.value, true, 0);
            } finally {
              setLoadingDevices(false);
            }
          }
        }}
        clusterOptions={clusterOptions}
        selectedCluster={selectedCluster}
        onClusterChange={setSelectedCluster}
        stateOptions={stateOptions}
        selectedState={selectedState}
        onStateChange={setSelectedState}
        nocOptions={nocOptions}
        selectedNoc={selectedNoc}
        onNocChange={setSelectedNoc}
        plantOptions={plantOptions}
        selectedPlant={selectedPlant}
        onPlantChange={setSelectedPlant}
        devicesArray={devicesArray}
        selectedDevices={selectedDevices}
        onDeviceToggle={handleCheckboxChange}
        onSelectAllDevices={(e) => {
          if (e.target.checked) {
            setSelectedDevices([
              ...selectedDevices.filter((id) =>
                devicesArray.find((d) => d.id === id && d.name === deviceId),
              ),
              ...devicesArray
                .filter((d) => d.name !== deviceId)
                .map((d) => d.id),
            ]);
          } else {
            setSelectedDevices(
              selectedDevices.filter((id) =>
                devicesArray.find((d) => d.id === id && d.name === deviceId),
              ),
            );
          }
        }}
        loadingDevices={loadingDevices}
        onLoadMore={() => setCurrentPage((prev) => prev + 1)}
        onSave={handleSaveLogicToDevices}
        saveDisabled={!patchName}
        inputBg={panelBg}
        textColor={optionText}
        footerError={!patchName}
        footerErrorText="Patch name is required."
        deviceId={deviceId}
        preselectedDevices={preselectedPatchDevices}
        showMainInputDisabled={true}
      />
    </>
  );
};

export default Logic;
